import Typograf from 'typograf';

let tp = new Typograf({ locale: ['ru', 'en-US'] });

function typograf(text) {
  return tp.execute(text);
}

export { typograf };
